module.exports = __webpack_public_path__ + "img/principles.e15a2958.jpg";